import { useQuery } from "@tanstack/react-query";
import taxReturnService from "../api/taxReturnService";

export const useTaxYears = () => {
  const { getTaxYears } = taxReturnService();

  return useQuery({
    queryKey: ["get-tax-years"],
    queryFn: async () => {
      const res = await getTaxYears();
      return res.data;
    },
  });
};
